module.exports = {"yytx04":{"daobanList":[{"title":"1:是否办理失业保险关系转移接续申请","values":[{"name":"是","xuanzhong":1,"cailiaoList":[{"name":"1、失业保险关系转移申请书","state":"必要"},{"name":"2、身份证","state":"必要"},{"name":"3、失业保险关系转移凭证","state":"必要"},{"name":"4、户口簿","state":"非必要"},{"name":"5、失业保险关系转移联系函","state":"非必要"},{"name":"6、中华人民共和国外国人永久居留身份证","state":"必要"}]},{"name":"否","xuanzhong":1,"cailiaoList":[{}]}]}]}}


//////////////////
// WEBPACK FOOTER
// ./static/js/situation/yytx04.json
// module id = 1303
// module chunks = 0